module.exports = __webpack_public_path__ + "img/resched-right.698674ee.svg";